import { logError } from 'utils/monitoring';
import { generateTabId, isBroadcastChannelSupported } from 'utils/timecardBroadcast';

export type ImpersonationBroadcastMessage = {
    type: 'IMPERSONATION_CHANGED';
    payload: { senderId: string };
};

const tabId = generateTabId();

export function getImpersonationTabId(): string {
    return tabId;
}

// Fixed name, unlike the per-user timecard channel: the backend session cookie is
// origin-wide, so tabs still displaying the old user must hear identity changes too.
export function createImpersonationBroadcastChannel(): BroadcastChannel {
    return new BroadcastChannel('impersonation-sync');
}

export function isImpersonationBroadcastMessage(data: unknown): data is ImpersonationBroadcastMessage {
    if (!data || typeof data !== 'object') return false;
    const message = data as Partial<ImpersonationBroadcastMessage>;
    return message.type === 'IMPERSONATION_CHANGED' && typeof message.payload?.senderId === 'string';
}

export function broadcastImpersonationChange(): void {
    if (!isBroadcastChannelSupported()) return;
    try {
        const channel = createImpersonationBroadcastChannel();
        const message: ImpersonationBroadcastMessage = {
            type: 'IMPERSONATION_CHANGED',
            payload: { senderId: tabId },
        };
        channel.postMessage(message);
        // postMessage enqueues delivery synchronously, so the throwaway channel can close at once
        channel.close();
    } catch (error) {
        logError(error);
    }
}
